import axios from "axios";

let timeoutCallbacks = null;

export const setTimeoutResetCallback = (callbacks) => {
    timeoutCallbacks = callbacks;
};


axios.interceptors.request.use(
    config => {
        // Pause session timeout during API calls
        if (timeoutCallbacks?.pauseTimeout) {
            timeoutCallbacks.pauseTimeout();
        }

        const token = localStorage.getItem('Token');
        const sessionStorageToken = sessionStorage.getItem('Token');
        console.log(token);
        // debugger;
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        } else{
            config.headers['Authorization'] = 'Bearer ' + sessionStorageToken;
        }
        return config;
    },
    error => {
        Promise.reject(new Error(error));
    }
);


axios.interceptors.response.use((response) => { // block to handle success case
    // Resume session timeout after API completes
    if (timeoutCallbacks?.resumeTimeout) {
        timeoutCallbacks.resumeTimeout();
    }
    return response;
}, function (error) { // block to handle error case
    // Resume session timeout after API error
    if (timeoutCallbacks?.resumeTimeout) {
        timeoutCallbacks.resumeTimeout();
    }
    console.log("error", error);
    if (error?.response?.data) {
        return Promise.reject(error.response.data);
    }

    return Promise.reject("Unable to process request");
});



// Code Blocked on 23-12-2025 - Starts here

// import axios from "axios";
// console.log("req inside interceptor", axios.interceptors.request);
// axios.interceptors.request.use(
//     config => {
//         // debugger;
//         const token = localStorage.getItem('Token');
//         if (token) {
//             config.headers['Authorization'] = 'Bearer ' + token;
//         }
//         // config.headers['Content-Type'] = 'application/json';
//         return config;
//     },
//     error => {
//         Promise.reject(error)
//     });

// Code Blocked on 23-12-2025 - Ends here

// import axios from "axios";

// const ITOKEN = process.env.REACT_APP_INTERACTTOKEN;
// console.log("ITOKEN", ITOKEN);


// axios.interceptors.request.use(
    
//     config => {
//         // debugger;    
//         if (config.url.includes("/GCApi/user/authenticate")) {
//             console.log("config.url", config.url);
//             config.headers['Content-Type'] = 'application/json'
//             config.headers['Authorization'] = 'Basic ' + ITOKEN;
//         } else {
//             //const token = localStorage.getItem('Token');
//             const token = config.headers.Authorization;
//             console.log("Ftoken", token);

//             if (token) {
//                 config.headers['Authorization'] = token;
//             }

//         }
//         return config;
//     },
//     error => {
//         Promise.reject(error)

//     });


// axios.interceptors.response.use((response) => {
//     return response
// }, function (error) {

//     console.log("errorincpt", error)
//     if (error?.response?.data?.Message) {
//         return Promise.reject(error.response.data.Message);
//     }
//     if (ITOKEN) {
//         return Promise.reject(error)
//     } else {
//         return Promise.reject("Unable to process request");
//     }
// });
